import { Alert } from "@mui/material"
import dayjs from "dayjs";
import React from 'react'
import { useTranslation } from "react-i18next";

/**
 * @param {Object} props 
 * @param {"SUSPENDED" | "TERMINATED"} props.status
 * @param {string} props.remark
 * @param {string | Date} props.date
 * @returns 
 */
const AccountStatusAlert = ({
  status,
  remark,
  date
}) => {
  const { t: tLocal } = useTranslation("translation", { keyPrefix: "form.onlineMerchantManagement.components.accountStatusAlert" });

  const severity = (() => {
    switch (status) {
      case "SUSPENDED":
        return "warning";
      case "TERMINATED":
        return "error";
      default:
        return "info";
    }
  })();

  return (
    <Alert variant="filled" severity={severity}>
      {tLocal("message", { status, remark, time: dayjs(date).format("YYYY-MM-DD HH:mm:ss") })}
    </Alert>
  )
}

export default AccountStatusAlert